'use client'

import { useId, useRef } from 'react'
import { Box, Fade, Grid, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { Trans, useTranslation } from 'react-i18next'
import useOnScreen from '@hooks/useOnScreen'

const RootGrid = styled(Grid)(({ theme }: any) => ({
  textAlign: 'center',
  paddingTop: theme.spacing(12),
  paddingBottom: theme.spacing(12),
}))

const Title = styled(Typography)(() => ({
  textAlign: 'center',
}))

const CustomImage = styled('img')`
  height: 5rem;
  max-width: 100%;
  object-fit: cover;
  margin: 0 auto;
`

const ImageContainer = styled(Box)`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  z-index: 2;
`

function RightFromTheBeginningSection() {
  const { t } = useTranslation()
  const id = useId()
  const root = useRef()
  const isVisible = useOnScreen(root)

  const imageTitles: any = t('RightFromTheBeginningPage.images', {
    returnObjects: true,
  })

  const images = [
    {
      src: '/assets/icons/mirror.png',
      title: imageTitles[0].title,
    },
    {
      src: '/assets/icons/blockchain.png',
      title: imageTitles[1].title,
    },
    {
      src: '/assets/icons/cat-in-box.png',
      title: imageTitles[2].title,
    },
    {
      src: '/assets/icons/key.png',
      title: imageTitles[3].title,
    },
  ]

  return (
    <Fade in={isVisible} timeout={2000} ref={root}>
      <RootGrid
        container
        spacing={8}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Title variant="h4">
            <Trans i18nKey="RightFromTheBeginningPage.title" />
          </Title>
        </Grid>
        {images.map((image, index) => (
          <Grid item xs={8} sm={6} md={2.4} key={id}>
            <ImageContainer>
              <CustomImage
                src={image.src}
                key={`image-${id}`}
                alt={`image-${index}`}
              />
              <Typography variant="caption">{image.title}</Typography>
            </ImageContainer>
          </Grid>
        ))}
      </RootGrid>
    </Fade>
  )
}

export default RightFromTheBeginningSection
